import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MarketingMaterialComponent } from '../modal/marketing-material/marketing-material.component';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { GET_CMGC_PRODUCT_DETAILS, GET_REDIRECT_PAGE, GET_SWITCH_SITE, ISSUE_NEW } from '@store/sat-motor/sat-motor.action';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { CROSS_SELL_ISSUE_NEW_REDIRECT_TO_ALPHA } from '@store/user/user.action';

@Component({
  selector: 'app-cross-sell-banner',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './cross-sell-banner.component.html',
  styleUrl: './cross-sell-banner.component.scss'
})
export class CrossSellBannerComponent implements OnInit, AfterViewInit {
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @Input() crossSellList: any;
  @Input() userInfo: any;
  @Input() marketingConsent: any;
  @Input() clientPartnerInfo: any;
  @Input() agentInfo: any;
  @Input() isApproval: boolean;
  marketingMaterialModal?: NxModalRef<MarketingMaterialComponent>;

  currentIndex = 0;
  showPagination = false;
  imagesPerView = 2; // Default for large screens
  totalPages = 0;

  touchStartX = 0;
  touchEndX = 0;

  constructor(
    private readonly dialogService: NxDialogService,
    private store: Store,
    private router: Router
  ) {}

  @HostListener('window:resize') onWindowResize() {
    this.checkScreenSize();
  }

  @HostListener('wheel', ['$event'])
  onMouseScroll(event: WheelEvent) {
    if (this.isCursorOnBanner(event)) {
      event.preventDefault();
      if (event.deltaY > 0) {
        this.nextImage();
      } else {
        this.prevImage();
      }
    }
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.touches[0].clientX;
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].clientX;
    this.handleSwipe();
  }

  ngOnInit() {
    this.checkScreenSize();
  }

  ngAfterViewInit() {
    this.checkScreenSize();
  }

  openPopUpMarketingMaterial(crossSell) {
    this.marketingMaterialModal = this.dialogService.open(MarketingMaterialComponent, {
      minWidth: '70vw',
      maxWidth: '90vw',
      maxHeight: '90vh',
      showCloseIcon: true,
      disableClose: true,
      data: {
        crossSell: crossSell,
        customerPartnerInfo: this.clientPartnerInfo,
        userInfo: this.userInfo,
        agentInfo: this.agentInfo,
        isApproval: this.isApproval
      }
    });
  }

  getCSRedirectURL(crossSell) {
    this.store.dispatch(new GET_CMGC_PRODUCT_DETAILS({
      agentCode: this.agentInfo.agentCode,
      productCode: crossSell.productCode
    })).subscribe((stateLevel1) => {
      let cmgcProductDetails = stateLevel1.SatMotorState.cmgcProductDetails;
      if (cmgcProductDetails) {
        if (cmgcProductDetails.productType == "MT") {
          if(cmgcProductDetails.satCloudInd) {
            this.normalRedirection(crossSell);
          }else {
            this.redirectToAlpha(crossSell);
          }
        } else {
          this.normalRedirection(crossSell);
        }
      }else {
        this.normalRedirection(crossSell);
      }
    });
  }

  normalRedirection(crossSell) {
    const payload = {
      agentCode: this.agentInfo.agentCode,
      documentNo: '',
      operator: this.userInfo.userId,
      userId: this.userInfo.userId,
      productType: crossSell?.productType,
      action: 'ISSUE',
      contractId: '',
      productCode: crossSell.productCode,
      cnoteType: 'NW',
      idType: this.clientPartnerInfo.idType1,
      idValue: this.clientPartnerInfo.idValue1,
      clientType: this.clientPartnerInfo.clientType,
      // renewNow: false,
      // equote: false
    };

    this.store.dispatch(new GET_REDIRECT_PAGE(payload)).subscribe((state) => {
    });

  }

  redirectToAlpha(crossSell) {
    const payload = {
      agentCode: this.agentInfo.agentCode,
      documentNo: '',
      operator: this.userInfo.userId,
      userId: this.userInfo.userId,
      productType: crossSell?.productType,
      action: 'ISSUE',
      contractId: '',
      productCode: crossSell.productCode,
      cnoteType: 'NW',
      idType: this.clientPartnerInfo.idType1,
      idValue: this.clientPartnerInfo.idValue1,
      clientType: this.clientPartnerInfo.clientType,
      // renewNow: false,
      // equote: false
    };
    this.store.dispatch(new CROSS_SELL_ISSUE_NEW_REDIRECT_TO_ALPHA(payload));
  }

  disableIssueNew() { //AGIC-51152
    if(this.marketingConsent == undefined || this.marketingConsent) {
      if(!this.hasCoverNoteAccess()) {
        return true;
      }

      if(this.userInfo.userType === "AG" || this.isBranchSupport) {
        return false;
      }

      return this.userInfo.adminType === "HQ" || this.userInfo.adminType === "BDM"; 
    }else {
      return true;
    }
  }

  disableMarketingMaterial() { //AGIC-51152
    if(this.marketingConsent == undefined || this.marketingConsent) {
      if (this.marketingConsent === 'N' || this.marketingConsent === 'NO') {
        return true;
      }

      if (this.userInfo.userType !== "AG" && !this.isBranchSupport) {
        return true;
      }

      return this.userInfo.adminType === "HQ" || this.userInfo.adminType === "BDM"; 
    }else {
      return true;
    }
  }

  prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.totalPages - 1; // Loop to last
    }
    this.scrollToCurrentImage();
  }

  nextImage() {
    if (this.currentIndex < this.totalPages - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Loop back to first
    }
    this.scrollToCurrentImage();
  }

  scrollToCurrentImage() {
    if (this.scrollContainer) {
      const scrollAmount = this.currentIndex * this.scrollContainer.nativeElement.clientWidth / this.imagesPerView;
      this.scrollContainer.nativeElement.scrollTo({ left: scrollAmount, behavior: 'smooth' });
    }
  }

  isCursorOnBanner(event: WheelEvent): boolean {
    if (!this.scrollContainer) return false;

    const banner = this.scrollContainer.nativeElement;
    const rect = banner.getBoundingClientRect();


    return event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
  }

  handleSwipe() {
    const swipeThreshold = 50; // Minimum swipe distance in pixels
    const swipeDistance = this.touchStartX - this.touchEndX;

    if (swipeDistance > swipeThreshold) {
      this.nextImage(); // Swipe left → next image
    } else if (swipeDistance < -swipeThreshold) {
      this.prevImage(); // Swipe right → previous image
    }
  }

  setCurrentIndex(index: number) {
    this.currentIndex = index;
    this.scrollToCurrentImage();
  }

  checkScreenSize() {
    const screenWidth = window.innerWidth;
    this.imagesPerView = screenWidth <= 993 ? 1 : 2; // Mobile: 1 image, Large: 2 images
    if(this.imagesPerView === 1) {
      this.totalPages = this.calculateMediumAndSmallTotalPages();
    }else {
      this.totalPages = this.calculateLargeScreenTotalPages();
    }
    this.showPagination = this.crossSellList.length > this.imagesPerView; // Show only if needed
  }

  calculateLargeScreenTotalPages() {
    if(this.crossSellList.length <= 2) {
      return Math.max(1, Math.ceil(this.crossSellList.length / this.imagesPerView));
    }else {
      return this.crossSellList.length - 1;
    }
  }

  calculateMediumAndSmallTotalPages() {
    return this.totalPages = Math.max(1, Math.ceil(this.crossSellList.length / this.imagesPerView));
  }

  hasCoverNoteAccess() {
    if (this.userInfo && this.userInfo.menuAccess) {
      if (this.userInfo.menuAccess.includes('SAT_MT_CN')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get isBranchSupport() {
    return this.userInfo?.issueOnBehalf;
  }

}
